import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BasketballGameApi, Game, handleError, VolleyballGameApi } from '@mtgame/core';
import { LoaderService } from '@mtgame/ui';

@Component({
  selector: 'mtg-volleyball-game-documents',
  templateUrl: './volleyball-game-documents.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VolleyballGameDocumentsComponent {
  @Input()
  game: Game;

  constructor(
    private loaderService: LoaderService,
    private volleyballGameApi: VolleyballGameApi,
  ) {
  }

  async downloadProtocol(fileType: 'pdf' | 'xlsx'): Promise<void> {
    this.loaderService.show();
    try {
      const response = await this.volleyballGameApi.downloadProtocolLight(this.game.id, fileType);
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(response);
      a.href = url;
      a.download = `Протокол ${this.game.team.name} - ${this.game.competitorTeam.name}.${fileType}`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      handleError(e);
    } finally {
      this.loaderService.hide();
    }
  }

  async downloadStatistic(fileType: 'pdf' | 'xlsx'): Promise<void> {
    this.loaderService.show();
    try {
      const response = await this.volleyballGameApi.downloadProtocol(this.game.id, fileType);
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(response);
      a.href = url;
      a.download = `Протокол ${this.game.team.name} - ${this.game.competitorTeam.name}.${fileType}`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      handleError(e);
    } finally {
      this.loaderService.hide();
    }
  }
}
